const { ValidationError } = require('@plastiq/external-api-errors')
const { isNullOrUndefined } = require('./helpers')

class BaseValidator {
  static guardAgainstNullOrUndefined(argument, argumentName) {
    if (isNullOrUndefined(argument)) {
      throw new ValidationError(`Missing required field: ${argumentName}`)
    }
  }

  static guardAgainstIncorrectTypes(argument, argumentName, argumentType) {
    if (typeof argument !== argumentType) {
      throw new ValidationError(
        `Must be of type ${argumentType}: ${argumentName}`,
      )
    }
  }

  static validateLength(argument, argumentName, minLength, maxLength) {
    const argumentLength = argument.length
    const LESS_THAN_MIN_LENGTH = minLength && argumentLength < minLength
    const MORE_THAN_MAX_LENGTH = maxLength && argumentLength > maxLength

    if (LESS_THAN_MIN_LENGTH || MORE_THAN_MAX_LENGTH) {
      throw new ValidationError(`Invalid length: ${argumentName}`)
    }
  }
}

module.exports = BaseValidator
